import { ComponentProps } from "react";
import Toggle from "react-toggle";
import { cn } from "@/shared/utils/cn";

const booleanToggleClassName = cn(
  "[&.react-toggle--checked_.react-toggle-track]:!bg-primary",
  "[&.react-toggle--checked_.react-toggle-thumb]:!border-primary",
);

const Boolean = ({ className, ...props }: ComponentProps<typeof Toggle>) => (
  <Toggle {...props} className={cn(booleanToggleClassName, className)} />
);

export default Boolean;
